import { evaluateCondition } from './condition.js';
import { encode } from 'utf8';
import { murmur3 } from 'murmurhash-js';

const FALLBACK_TREATMENT = 'control';
class ExperimentService {
    constructor(state) {
        this._state = state;
        this.evaluate = this.evaluate.bind(this);
    }
    evaluate(experimentName, subject) {
        const experiment = this._state.experiments.get(experimentName);
        if (!experiment) {
            return { value: FALLBACK_TREATMENT, version: -1 };
        }
        const rule = experiment.rules.find(rule => evaluateCondition(subject, rule.condition));
        if (!rule) {
            // No condition in the rule can match the subject
            return { value: FALLBACK_TREATMENT, version: experiment.version };
        }
        if (rule.partitions.length == 1 && rule.partitions[0].percentage == 100) {
            // 100% shortcut
            return { value: rule.partitions[0].treatmentValue, version: experiment.version };
        }
        let bucket = this.getBucket(subject.id, experiment.seed);
        for (const partition of rule.partitions) {
            if (partition.percentage >= bucket) {
                return { value: partition.treatmentValue, version: experiment.version };
            }
            bucket -= partition.percentage;
        }
        return { value: FALLBACK_TREATMENT, version: experiment.version };
    }
    getBucket(id, seed) {
        return (murmur3(encode(id), seed) % 100) + 1;
    }
}

export { ExperimentService };
//# sourceMappingURL=service.js.map
